// flowRemountKey returns the React `key` for the ReactFlow canvas. ReactFlow is remounted
// (which re-runs onInit and recenters on the root node) only when this key changes, so the
// key must depend ONLY on the user's chosen context — the dimension and the Active/Draft
// view. It deliberately ignores the node list: adding, removing, renaming or moving a node
// must keep the same key so the user's current pan/zoom survives the edit instead of
// snapping back to the root.
export function flowRemountKey({ dimensionId, viewMode }) {
  return `${dimensionId ?? "none"}-${viewMode ?? "active"}`;
}
